import * as React from 'react';
import { AccountContextProvider } from '../../components/blogs/AccountContext';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { TemplateDesignFormContainer } from '../../containers/blogs/TemplateDesigner/TemplateDesignFormContainer';

export const AdminAccountBlogTemplateDesignerPage: React.FC = () => {
	return (
		<AdminDashboardPageLayout>
			<AccountContextProvider>
				<TemplateDesignFormContainer />
			</AccountContextProvider>
		</AdminDashboardPageLayout>
	);
};
